// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import type { PickedPhoto } from '@/features/tour-photos/types';

/** What a boundary stake marks. Only out of bounds becomes a line today. */
export type StakeKind = 'out-of-bounds' | 'penalty-red' | 'penalty-yellow';

export const STAKE_KINDS: readonly StakeKind[] = ['out-of-bounds', 'penalty-red', 'penalty-yellow'];

/**
 * One stake as the phone recorded it, standing next to it.
 *
 * The position is the phone's, averaged over the last few seconds of standing still; the
 * heading is which way the mapper faced when the camera opened, which is the side that is out.
 * Both are frozen before the camera opens, because a mapper turns to frame a picture.
 */
export type StakeObservation = {
  /** Client-generated; the S3 key and the server row are both decided by it. */
  id: string;
  courseId: string;
  holeNumber: number;
  stakeKind: StakeKind;
  lat: number;
  lon: number;
  accuracyMeters: number;
  /** Degrees clockwise from north, or null when the compass was not trusted. */
  headingDegrees: number | null;
  /** The platform's calibration level at capture (0–3), or null. */
  headingAccuracy: number | null;
  /** ISO-8601. */
  capturedAt: string;
};

export type StakeUploadJob = {
  stake: StakeObservation;
  /** Null for a stake marked without a picture. */
  photo: PickedPhoto | null;
};

export type StakeUploadStatus = 'pending' | 'uploading' | 'done' | 'failed';

export type StakeUploadEntry = {
  job: StakeUploadJob;
  status: StakeUploadStatus;
  error: string | null;
};
